<template>
  <div class="withdraw-options">

    <div class="option crypto" @click="$emit('select-crypto')">
      <div class="option-bg">
        <img src="@/assets/img/cashier/30.png" />
      </div>

      <div class="option-content">
        <h3>Crypto</h3>
        <p>30+ Coins & Networks</p>
      </div>
    </div>

    <div class="option fiat disabled">
      <div class="option-bg">
        <img src="@/assets/img/cashier/31.png" />
      </div>

      <div class="option-content">
        <h3>Fiat</h3>
        <p>Coming soon</p>
      </div>
    </div>

  </div>
</template>

 


<style scoped>
 .withdraw-options {
  display: flex;
  gap: 35px;
   
  margin-top: 25px;
}

/* OPTION */
.option {
  position: relative;
  flex: 1;
  height: 120px;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;

  display: flex;
  align-items: flex-end;
  padding: 16px;

  box-shadow:
    0 8px 24px rgba(0,0,0,.35),
    inset 0 1px 0 rgba(255,255,255,.05);
}

/* BACKGROUNDS */
.option.crypto {
  background: linear-gradient(180deg,#1f3636,#0e1b22);
}

.option.fiat {
  background: linear-gradient(180deg,#46371f,#1a140b);
}

/* IMAGE LAYER */
.option-bg {
   width: 100%;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.25;
}

.option-bg img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.6));
}

/* CONTENT */
.option-content {
  position: relative;
  z-index: 2;
}

.option-content h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.option-content p {
  margin: 4px 0 0;
  font-size: 13px;
  color: rgba(255,255,255,.75);
}

/* DISABLED */
.option.disabled {
  opacity: 0.99;
  cursor: not-allowed;
}

</style>